import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const MaskedLine = ({ children, delay = 0, className = "", innerClassName = "" }) => (
  <motion.span
    className={`block overflow-hidden ${className}`}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: "-8%" }}
  >
    <motion.span
      className={`block will-change-transform ${innerClassName}`}
      variants={{
        hidden: { y: "115%" },
        visible: { y: 0, transition: { duration: 1, delay, ease: EASE } },
      }}
    >
      {children}
    </motion.span>
  </motion.span>
);

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 48 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8%" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);
